import { useCallback, useRef } from 'react';
import { RaptorPDFViewerHandle } from '../../../../general/raptorPDFViewer/RaptorPDFViewer';

/**
 * Custom hook for synchronized scrolling between two PDF viewers
 * @returns Object containing refs and scroll handlers for both PDF viewers
 */
export const useSynchronizedPdfScroll = () => {
  const targetPdfRef = useRef<RaptorPDFViewerHandle>(null);
  const comparePdfRef = useRef<RaptorPDFViewerHandle>(null);

  // Synchronized scrolling handlers
  const handleTargetScroll = useCallback((scrollTop: number) => {
    if (comparePdfRef.current) {
      comparePdfRef.current.scrollTo(scrollTop);
    }
  }, []);

  const handleCompareScroll = useCallback((scrollTop: number) => {
    if (targetPdfRef.current) {
      targetPdfRef.current.scrollTo(scrollTop);
    }
  }, []);

  return {
    targetPdfRef,
    comparePdfRef,
    handleTargetScroll,
    handleCompareScroll,
  };
};
